import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureDataLakeStoreCosmosStructuredStreamLinkedService } from 'app/model/linkedservice/azure-data-lake-store-cosmos-structured-stream.linkedservice';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { FileTypeDataset } from './file-type.dataset';
import { FileFormat } from './file-format';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureDataLakeStoreCosmosStructuredStream_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureDataLakeStoreCosmosStructuredStream_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureDataLakeStoreCosmosStructuredStreamLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureDataLakeStoreCosmosStructuredStreamFileDataset extends FileTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly GENERATED_FROM_ACTIVITY: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_GeneratedFromActivity,
        association: 'GENERATED_FROM_ACTIVITY'
    })
    public generatedFromActivity?: boolean;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.format = new FileFormat();
        this.isV2 = true;
    }
}
